export interface ActionItem {
  id?: string | number;
  text?: string;
  icon?: string;
  divider?: boolean;
  header?: boolean;
  disabled?: boolean;
}
